export default __webpack_public_path__ + "static/media/seniority.9165f279.svg";